@if (sessions) {
  <div panel-list>
    <div>
      <div class-roster-body>
        <div class-roster-title>
          <h1>All Sessions</h1>
          <div (click)="downloadReport()" class="export-button">Export to Excel
            <img src="assets/icons/excel.svg" alt="" ml10>
          </div>
        </div>
      </div>
    </div>
    <div Class-list>
      <div head [attr.mode]="searchmode">
        <div left>
        </div>
        <div right>
          <span><i class="material-icons">settings</i></span>
          <span>Event Setting Mode</span>
          <span [ngClass]="{'disable':!isDisplay}" (click)="togglesession()"><i
          class="material-icons">clear</i></span>
          <span [ngClass]="{'disable':isDisplay}">
            <button (click)="cancel()">Cancel</button>
            <button (click)="save()">Save</button>
          </span>
          <div close class="undo">
            @if (isSaved) {
              <span save>Saved successfully</span>
            }
            @if (isSaved) {
              <span>
                <i class="material-icons"> check_circle_outline</i>
              </span>
            }
          </div>
        </div>
        <span><i class="material-icons">local_library</i></span>
        <div>Sessions ( Active - {{getSessionCount()}} )</div>
        <div right-head>
        </div>
        <div class="filter-select-items-cancel">
          <div>
            <label for="filter">Filter : </label>
            <select id="filter" [(ngModel)]="selectedFilter">
              <option value="all">All</option>
              <option value="notCancelled">Active</option>
              <option value="cancelled">Inactive</option>
            </select>
          </div>
        </div>
      </div>
      @if (selectedItems.size > 0) {
        <div class="delete-banner">
          {{ selectedItems.size }} Session(s) Selected |
          <button mat-button class="cancel-btn" (click)="cancelSelectedItems()">
            <mat-icon>cancel</mat-icon> Cancel Session(s)</button>
        </div>
      }
      @if (sessions?.length) {
        <table [attr.mode]="mode" class="table-fixedheader">
          <thead>
            <th class="edit" (click)="sort('startDate','status', $event)">
              <span>Status</span>
              <i class="material-icons" [ngClass]="{'active':isStatusAsc}"> arrow_drop_down</i>
            </th>
            <th class="edit" (click)="sort('checkInCode','', $event)">
              <span>Check-in Code</span>
              <i class="material-icons" [ngClass]="{'active':isCheckInCodeAsc}"> arrow_drop_down</i>
            </th>
            <th class="edit" (click)="sort('title','', $event)">
              <span>Session Name</span>
              <i class="material-icons" [ngClass]="{'active':isTitleAsc}">arrow_drop_down</i>
            </th>
            <th class="edit" (click)="sort('description','', $event)">
              <span>Session Description</span>
              <i class="material-icons" [ngClass]="{'active':isDescriptionAsc}">arrow_drop_down</i>
            </th>
            <th class="edit" (click)="sort('classId','', $event)"><span>Session ID</span>
            <i class="material-icons" [ngClass]="{'active':isIdAsc}"> arrow_drop_down</i>
          </th>
          <th class="view">
            <div>
              <div (click)="sort('title','', $event)">
                <span>Session Name</span>
                <i class="material-icons" [ngClass]="{'active':isTitleAsc}"> arrow_drop_down</i>
              </div>
              <div (click)="sort('classId','', $event)">
                <span>Session ID</span>
                <i class="material-icons" [ngClass]="{'active':isIdAsc}"> arrow_drop_down</i>
              </div>
            </div>
          </th>
          <th class="edit" (click)="sort('startDate','', $event)">
            <span>Date</span>
            <i class="material-icons" [ngClass]="{'active':isDateAsc}">arrow_drop_down</i>
          </th>
          <th class="edit" (click)="sort('startTime','', $event)">
            <span>Start / end time</span>
            <i class="material-icons" [ngClass]="{'active':isTimeAsc}">arrow_drop_down</i>
          </th>
          <th class="edit" (click)="sort('location','', $event)">
            <span>Location</span>
            <i class="material-icons" [ngClass]="{'active':isLocationAsc}">arrow_drop_down</i>
          </th>
          <th class="edit" (click)="$event?.stopPropagation()">
            <span>Attendees</span>
          </th>
          <th class="edit" (click)="$event?.stopPropagation()">
            @if (!isInactiveSessionSelected() && !isSessionValid()) {
              <div>
                <!-- <div *ngIf="!isInactiveSessionSelected(); else inActiveSessionsFilter"> -->
                <input type="checkbox" [checked]="areAllSelectableRowsChecked()"
                  (change)="toggleSelectAll($event)" />
                </div>
              }
            </th>
          </thead>
          <tbody>
            @for (session of getFilteredItems() | orderBy : {property: column, direction: direction}; track session) {
              <tr
                [ngClass]="{ 'grayed-out': session.isCancelled }">
                <td class="disable edit">
                  <div>
                    <span></span>
                    <span class="{{session?.startDate |classcolor : session?.endDate }}">
                      {{session?.startDate |classstatus : session?.endDate }}
                    </span>
                  </div>
                </td>
                <td class="edit">
                  <div class="normal">
                    {{session?.isCpeEligible===true ? session?.checkInCode:''}}
                  </div>
                </td>
                <td class="edit">
                  <div class="anchor">
                    <span matTooltip="This session is cancelled" [matTooltipDisabled]="!session.isCancelled"
                    (click)='!session.isCancelled && openDialog(session)'>{{session?.title}}</span>
                  </div>
                </td>
                <td class="desc">
                  @if (getStrippedDesc(session); as strippedDesc) {
                    <div class="desc-wrapper">
                      <!-- SHORT TEXT -->
                      <div matTooltip="This session is cancelled" [matTooltipDisabled]="!session.isCancelled"
                        (click)="openDialog(session)">
                        {{ strippedDesc.length > 20
                        ? strippedDesc.slice(0, 20)
                        : strippedDesc
                        }}
                      </div>
                      <!-- SEE MORE (new line, smaller, same style) -->
                      @if (strippedDesc.length > 20) {
                        <div class="see-more"
                          (click)='!session.isCancelled && openDialog(session)'>
                          See More
                        </div>
                      }
                    </div>
                  }
                </td>
                <td class="edit">
                  <div>
                    <div>
                      <span>{{session?.classId}}</span>
                    </div>
                  </div>
                </td>
                <td class="view">
                  <div>
                    <span>{{session?.title}}</span>
                    <span>{{session?.classId}}</span>
                  </div>
                </td>
                <td class="default">
                  <div>
                    <span>
                      <input type="checkbox" class="example-margin" value="{{session?.eventSetting?.qa}}"
                        name="qa" (change)="toggleEventChange($event, session?.eventSetting)" />
                      </span>
                    </div>
                  </td>
                  <td class="edit">
                    <div>
                      <span><i class="material-icons">date_range</i></span>
                      <div>
                        <span>{{session?.startDate | dateFormat : 'mmddyyyy'}}</span>
                        <span>{{session?.startDate | dateFormat : 'fulldayname'}}</span>
                      </div>
                    </div>
                  </td>
                  <td class="edit">
                    <div>
                      <span><i class="material-icons">access_time</i></span>
                      <div>
                        <span>{{session?.startDate | timeFormat}} - </span>
                        <span>{{session?.endDate | timeFormat}} ET</span>
                      </div>
                    </div>
                  </td>
                  <td class="edit">
                    <div>
                      <span><img src="assets/icons/location-table.svg" alt=""></span>
                      <span>{{session?.location}} </span>
                    </div>
                  </td>
                  <td class="edit">
                    <div>
                      <div>
                        <span>Participants</span>
                      </div>
                      <div>
                        <span>{{session?.participants || 0}}</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    @if (isCompletedOrCancelled(session?.startDate,session?.endDate, session.isCancelled)) {
                      <div class="cancel-check-btn">
                        <input type="checkbox" [checked]="selectedItems.has(session.id)"
                          [disabled]="session.isCancelled" (change)="toggleSelection(session)" />
                          <button matTooltip="Cancel Session" matTooltipPosition="above" mat-icon-button color="warn"
                            (click)="cancelItem(session)" [disabled]="session.isCancelled">
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </div>
                      } @else {
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          } @else {
            <p class="background-white m-t-xs noResults">
              <span class="m-l-lg">
                <error-message [errorMessage]="errorMessage"></error-message>
              </span>
            </p>
          }
        </div>
      </div>
    } @else {
      @if (showLoading) {
        <div class="loading">
          <mat-spinner></mat-spinner>
        </div>
      } @else {
        <p class="background-white m-t-xs noResults">
          <span class="m-l-lg">
            <error-message [errorMessage]="errorMessage"></error-message>
          </span>
        </p>
      }
    }


    @if (showLoading) {
      <div>
        <div class="loading">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    }

    <ng-template #inActiveSessionsFilter>
      <input type="checkbox" [disabled]="true" />
    </ng-template>

